import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader} from "react-overlay-loader";

class SamlRedirect extends Component {
    state = {
        redirect: this.props.redirect,
    }

    componentDidMount(){
        window.location.href = this.state.redirect;
    }

    render() {
        return (
            <div>
                <Loader fullPage={true} loading={true}/>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        redirect: state.login.redirect,
    }
}

export default connect(mapStateToProps)(SamlRedirect)